import React, { CSSProperties, HTMLAttributeAnchorTarget, useState } from 'react';
import * as styles from './index.module.less';
import ButtonWrapper from '../button-wrapper';
import { PublicArrowRightTail } from 'notta-web-icon';

interface IProp {
  label: string;
  link?: string;
  target?: HTMLAttributeAnchorTarget;
  onClick?: () => void;
  style?: CSSProperties;
  labelStyle?: CSSProperties;
  btnWrapperStyle?: CSSProperties;
  btnWrapperClass?: string;
  labelClass?: string;
  defaultStyle?: {
    background?: string;
    color?: string;
  };
  hoverStyle?: {
    background?: string;
    color?: string;
  };
  activeStyle?: {
    background?: string;
    color?: string;
  };
  borderColor?: string;
  className?: string;
  isShowArrow?: boolean;
  prefix?: any;
  suffix?: any;
  buttonType?: 'button' | 'submit' | 'reset';
  children?: any;
  [key: string]: any;
}

const Button = ({
  label,
  style,
  defaultStyle,
  hoverStyle,
  activeStyle,
  borderColor,
  className,
  children,
  labelStyle,
  labelClass,
  buttonType = 'button',
  isShowArrow = false,
  prefix,
  suffix,
  onClick,
  ...others
}: IProp) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setIsActive(false);
  };

  const handleMouseDown = () => {
    setIsActive(true);
  };

  const handleMouseUp = () => {
    setIsActive(false);
  };

  return (
    <button
      type={buttonType}
      onClick={onClick}
      className={`${styles.btn_container} ${borderColor && styles.btn_with_border_container} ${className}`}
      style={Object.assign(
        {},
        defaultStyle,
        style,
        isHovered && hoverStyle,
        isActive && activeStyle,
        borderColor && {
          border: `2px solid ${borderColor}`,
          borderRadius: `12px`,
        },
      )}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      {...others}
    >
      <span className={`${styles.btn_label} ${labelClass}`} style={labelStyle}>
        {prefix}
        {label}
        {suffix}
        {isShowArrow && <PublicArrowRightTail className={styles.arrow} />}
      </span>
      {children}
    </button>
  );
};

const CommonBtn = ({
  label,
  link,
  onClick = () => {},
  target = '_self',
  defaultStyle,
  hoverStyle,
  activeStyle,
  borderColor,
  style,
  className,
  children,
  labelStyle,
  labelClass,
  btnWrapperClass,
  buttonType = 'button',
  isShowArrow = false,
  prefix,
  suffix,
  ...others
}: IProp) => {
  return (
    <ButtonWrapper link={link} target={target} className={btnWrapperClass}>
      <Button
        label={label}
        style={style}
        defaultStyle={defaultStyle}
        hoverStyle={hoverStyle}
        activeStyle={activeStyle}
        borderColor={borderColor}
        className={className}
        children={children}
        labelStyle={labelStyle}
        labelClass={labelClass}
        onClick={onClick}
        buttonType={buttonType}
        isShowArrow={isShowArrow}
        prefix={prefix}
        suffix={suffix}
        {...others}
      />
    </ButtonWrapper>
  );
};
export default CommonBtn;
